import React, { useState } from 'react';
import '../styles/Home.css';

const faqData = [
	{
		question: 'Why Consphic?',
		answer: 'Consphic transforms your brand with intuitive, visually stunning designs that elevate user experience, boost engagement, and drive measurable business success.',
	},
	{
		question: 'Why sets Consphic apart from the competition?',
		answer: 'Our unique blend of strategic creativity, user-focused design, and cutting-edge aesthetics ensures impactful, memorable brand interactions that stand out.',
	},
	{
		question: 'How can Consphic guarantee accurate reporting?',
		answer: 'Consphic delivers precise reporting through data-driven insights, transparent metrics, and tailored analytics, ensuring your business goals are tracked and achieved.',
	},
];

const FAQSection: React.FC = () => {
	const [openIdx, setOpenIdx] = useState<number | null>(null);
	return (
		<section className="faq-section">
			<div className="faq-left">
				<div className="faq-label">FAQS</div>
				<div className="faq-title">
					Do you have any
					<br />
					Question ?
				</div>
				<div className="faq-desc">
					Having questions or need more details? Reach out to us! We're committed
					to delivering a seamless, informative experience tailored to your needs.
				</div>
				<button className="faq-talk-btn">
					<span>Let's Talk</span>
					<span className="faq-btn-arrow-circle">
						<span className="faq-btn-arrow-bg">
							<svg
								width="18"
								height="18"
								viewBox="0 0 24 24"
								fill="none"
								stroke="#fff"
								strokeWidth="2.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							>
								<line x1="5" y1="12" x2="19" y2="12" />
								<polyline points="12 5 19 12 12 19" />
							</svg>
						</span>
					</span>
				</button>
			</div>
			<div className="faq-right">
				{faqData.map((item, idx) => (
					<div
						className={`faq-accordion${openIdx === idx ? ' open' : ''}`}
						key={idx}
						onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
					>
						<div className="faq-question-row">
							<span className="faq-question">{item.question}</span>
							<span className={`faq-plus${openIdx === idx ? ' open' : ''}`}>
								<svg
									className="faq-arrow-svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="#fff"
									strokeWidth="2.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<polyline points="6 9 12 15 18 9" />
								</svg>
							</span>
						</div>
						{openIdx === idx && item.answer && (
							<div className="faq-answer">{item.answer}</div>
						)}
					</div>
				))}
			</div>
		</section>
	);
};

export default FAQSection;
